import styled from "@emotion/styled";
import {
  FONT_SIZE_MEDIUM,
  BUTTON_SECONDARY_COLOR,
  COLOR_PRIMARY,
  HEADER_FONT_FAMILY,
  MOBILE_SCREEN,
  TEXT_FONT_FAMILY,
  FONT_SIZE_SMALL,
  COLOR_INPUT_DEFAULT_BORDER,
  COLOR_INPUT_BORDER_HOVER,
  COLOR_INPUT_BORDER_FOCUSED,
  COLOR_SECONDARY_BUTTON_DISABLED_BORDER,
  COLOR_SECONDARY_BUTTON_DISABLED_TEXT,
} from "../theme";

export const SecondaryButton = styled.button`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 16px 32px;
  border-radius: 100px;
  color: ${COLOR_PRIMARY};
  background-color: ${BUTTON_SECONDARY_COLOR};
  font-size: ${FONT_SIZE_MEDIUM};
  font-family: ${HEADER_FONT_FAMILY};
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  flex-shrink: 0;
  border: 1px solid ${COLOR_INPUT_DEFAULT_BORDER};
  transition: all 100ms ease-in-out;
  &:disabled {
    border: 1px solid ${COLOR_SECONDARY_BUTTON_DISABLED_BORDER};
    color: ${COLOR_SECONDARY_BUTTON_DISABLED_TEXT};
    cursor: not-allowed;
  }
  &:hover:not(:disabled):not(:focus) {
    border: 1px solid ${COLOR_INPUT_BORDER_HOVER};
  }
  &:focus {
    border: 1.5px solid ${COLOR_INPUT_BORDER_FOCUSED};
  }
  ${MOBILE_SCREEN} {
    gap: 8px;
  }
`;

export const SecondaryButtonSmall = styled(SecondaryButton)`
  height: 40px;
  font-weight: 500;
  padding: 3px 16px;
  gap: 8px;
  font-family: ${TEXT_FONT_FAMILY};
  font-size: ${FONT_SIZE_SMALL};
`;

export const SecondaryButtonSmallNormalWeight = styled(SecondaryButtonSmall)`
  font-weight: 400;
`;
